const { useState } = require('react');
const { default: Button } = require('@mui/material/Button');
const { default: TextField } = require('@mui/material/TextField');
const { runProfanityCheck } = require('utils/profanityFilter');
const InappropriateLanguageDialog = require('routes/app/components/Chat/InappropriateLanguageDialog');

module.exports = function SocialActivity({ activity, games, userId, usersNameMap = {}, useProfanityFilter }) {

    const [choices, setChoices] = useState([{ title: '', why: '' }, { title: '', why: '' }]);
    const [selected, setSelected] = useState([]);
    const [blocked, setBlocked] = useState(null);
    const disabled = games.busy || games.uncertain;
    const own = activity.contributions[userId];
    const both = Object.keys(activity.contributions).length === 2;
    const update = (index, field, value) => setChoices((old) => old.map((choice, i) => i === index ? { ...choice, [field]: value } : choice));
    const contribute = (e) => {

        e.preventDefault();
        if (disabled) { return; }
        const check = useProfanityFilter ? runProfanityCheck(choices.map((c) => `${c.title} ${c.why}`).join(' ')) : { passesCheck: true };
        if (!check.passesCheck) { setBlocked(check.badPhrases); return; }
        games.action('contribute', { choices });
    };

    return <section aria-label='Our Top Three activity'>
        <p>Each add two choices. Your contribution counts even if you prefer different things or leave before agreeing on a list.</p>
        {!own && activity.status === 'active' && <form onSubmit={contribute}>
            {choices.map((choice, i) => <div key={i}>
                <TextField fullWidth label={`Your choice ${i + 1}`} value={choice.title} onChange={(e) => update(i, 'title', e.target.value)} inputProps={{ maxLength: 120 }} disabled={disabled} margin='dense' />
                <TextField fullWidth label={`Why choice ${i + 1}? (optional)`} value={choice.why} onChange={(e) => update(i, 'why', e.target.value)} inputProps={{ maxLength: 300 }} disabled={disabled} margin='dense' />
            </div>)}
            <Button type='submit' variant='contained' disabled={disabled || choices.some((c) => c.title.trim().length < 2)}>Share my two choices</Button>
        </form>}
        {own && !both && <p>Your choices are saved. Your peer can contribute later; keep chatting in the meantime.</p>}
        {Object.entries(activity.contributions).map(([id, nominations]) => <div key={id}>
            <strong>{Number(id) === userId ? 'Your nominations' : `${usersNameMap[id] || 'Your peer'}’s nominations`}</strong>
            <ul>{nominations.map((c, i) => <li key={i}><strong>{c.title}</strong>{c.why && <> — {c.why}</>}</li>)}</ul>
        </div>)}
        {both && activity.status === 'active' && <>
            <p>Discuss your favorites in your peer chat. Choose {Math.min(3, activity.nominees.length)} for a shared list, or keep your own favorites. There is no wrong answer.</p>
            {activity.nominees.map((c) => <label key={c.id} style={{ display: 'block', padding: '8px 0' }}>
                <input type='checkbox' checked={selected.includes(c.id)} disabled={disabled} onChange={() => setSelected((old) => old.includes(c.id) ? old.filter((id) => id !== c.id) : [...old, c.id])} /> {c.title}{c.supporters.length > 1 ? ' · You both nominated this!' : ''}
            </label>)}
            <Button disabled={disabled || selected.length !== Math.min(3, activity.nominees.length)} onClick={() => games.action('propose', { selections: selected })}>Propose our list</Button>
        </>}
        {activity.proposal && <>
            <strong>Your shared shortlist</strong>
            <ul>{activity.proposal.map((id) => <li key={id}>{activity.nominees.find((c) => c.id === id)?.title}</li>)}</ul>
            {activity.status === 'active' && (activity.approvals.includes(userId) ? <p>Your proposal is saved. Your peer can approve it or suggest another list.</p>
                : <Button disabled={disabled} variant='contained' onClick={() => games.action('approve')}>That works for me</Button>)}
        </>}
        {activity.status === 'solved' && <p>You made a list together! Different tastes make a better conversation.</p>}
        <InappropriateLanguageDialog open={blocked !== null} words={blocked || []} onClose={() => setBlocked(null)} />
    </section>;
};
